import { useRouteQuery } from '@vueuse/router';

export default defineNuxtPlugin(() => {
  const casinoBotToken = useRouteQuery<string>('CasinoBot', '', {
    transform: getFirstRouteParam,
  });

  function getCaptchaDefaultTokenValue(isCaptchaBypassed: boolean) {
    return isCaptchaBypassed ? 'XXXX.DUMMY.TOKEN.XXXX' : '';
  }

  const initialTokenValue = computed<string>(() => {
    return getCaptchaDefaultTokenValue(
      casinoBotToken.value === 'C4C7U$B0tM0D3',
    );
  });

  return {
    provide: {
      captcha: {
        initialTokenValue,
      },
    },
  };
});
